import { render } from "./TableTrackings.vue?vue&type=template&id=6b46c8e8&scoped=true"
import script from "./tabletrackings.view.js?vue&type=script&lang=js&external"
export * from "./tabletrackings.view.js?vue&type=script&lang=js&external"

import "./tabletrackings.css?vue&type=style&index=0&id=6b46c8e8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b46c8e8"]])

export default __exports__